import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Vk = function Vk(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.633 3.843c.111-.37 0-.643-.53-.643h-1.75c-.445 0-.65.235-.761.495 0 0-.89 2.17-2.152 3.579-.407.408-.593.538-.816.538-.11 0-.272-.13-.272-.5v-3.47c0-.445-.129-.643-.5-.643h-2.75c-.279 0-.446.207-.446.402 0 .422.63.52.695 1.706v2.578c0 .565-.102.668-.324.668-.594 0-2.037-2.18-2.893-4.674-.168-.484-.336-.68-.783-.68H.6c-.5.001-.6.236-.6.496 0 .464.593 2.763 2.763 5.804 1.447 2.077 3.484 3.203 5.339 3.203 1.113 0 1.25-.25 1.25-.68v-1.57c0-.5.106-.6.458-.6.26 0 .705.13 1.743 1.13 1.187 1.188 1.383 1.72 2.05 1.72h1.75c.5 0 .75-.25.607-.743-.158-.492-.725-1.206-1.477-2.052-.408-.482-1.02-1.001-1.205-1.26-.26-.334-.186-.483 0-.78 0 0 2.132-3.004 2.355-4.024z",
    fill: "currentColor"
  }));
};
export default Vk;